/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-loader {
  border-radius: var(--qds-control-rounded-border-radius);
  box-sizing: border-box;
  color: var(--qds-theme-feedback-action-destructive-contrast);
}

[data-size='small'] {
  padding: var(--qds-signature-circle-progress-small-border-width);
  height: var(--qds-control-small-icon-size);
  width: var(--qds-control-small-icon-size);
}

[data-size='standard'] {
  padding: var(--qds-signature-circle-progress-standard-border-width);
  height: var(--qds-control-standard-icon-size);
  width: var(--qds-control-standard-icon-size);
}

[data-size='large'] {
  padding: var(--qds-signature-circle-progress-large-border-width);
  height: var(--qds-control-large-icon-size);
  width: var(--qds-control-large-icon-size);
}

[data-size='jumbo'] {
  padding: var(--qds-signature-circle-progress-jumbo-border-width);
  height: var(--qds-control-jumbo-icon-size);
  width: var(--qds-control-jumbo-icon-size);
}

[data-status='loading'] {
  animation: loading 1s linear infinite;
  background-image: var(--qds-theme-signature-circle-progress-indeterminate);
  /* stylelint-disable color-no-hex, declaration-property-value-no-unknown */
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  /* stylelint-enable color-no-hex, declaration-property-value-no-unknown */
  mask-composite: exclude;
}

@keyframes loading {
  to {
    transform: rotate(1turn);
  }
}

[data-status='success'] {
  background-color: var(--qds-theme-feedback-result-success);
}

[data-status='warning'] {
  background-color: var(--qds-theme-feedback-result-partial-success);
}

[data-status='error'] {
  background-color: var(--qds-theme-feedback-result-failure);
}
